import React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { withRouter } from "react-router-dom";
import MenuProfile from "./MenuProfile";
import APIUrl from "../../../APIUrl";
import { NavLink } from "react-router-dom";
import MenuLogo from "./MenuLogo";
import { logout } from "../../../actions/authentication/authentication";
import { Link } from "react-router-dom";
import Util from "../../../util/Util";

class MenuAdmin extends React.Component {
  /**
   * Compte le nombre de plateformes accessibles pour l'utilisateur
   */
  countAccessiblePlatforms() {
    const { user } = this.props;
    if (!user) return 0;
    let count = 0;
    if (user.access_e4coll) count++;
    if (user.access_e4mad) count++;
    if (user.access_e4vhp) count++;
    return count;
  }

  /**
   * Gère le clic sur le logo
   * - Si plusieurs plateformes accessibles → redirige vers Select App
   * - Sinon → ne fait rien
   */
  handleLogoClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const accessiblePlatforms = this.countAccessiblePlatforms();

    if (accessiblePlatforms > 1) {
      // Store a copy of the token before logout clears it
      let token = APIUrl.jwtToken;

      function onLogoutSuccess() {
        return window.location.replace(
          Util.checkHttps(process.env.REACT_APP_LOGIN_URL) + token,
        );
      }

      // Logout and redirect to e4login with token for platform selection
      this.props.onLogout(onLogoutSuccess);
    }
    // Si une seule plateforme accessible, ne fait rien
  }

  logout() {
    // Store a copy of the token before deleting it
    let token = APIUrl.jwtToken;

    // let that = this;

    function onLogoutSuccess() {
      // that.props.history.push('/');
      return window.location.replace(
        Util.checkHttps(process.env.REACT_APP_LOGIN_URL) + token,
      );
    }

    // Call logout and redirect on success
    this.props.onLogout(onLogoutSuccess);
  }

  render() {
    return (
      <nav className="navbar navbar-expand-lg menu">
        <div
          id="menu"
          className="collapse navbar-collapse mb-3 mb-md-0 mt-2 pb-2"
        >
          <ul className="navbar-nav list-inline text-center align-items-center">
            <li className="nav-item list-inline-item align-middle">
              <Link
                to="/#"
                className="logo-item"
                onClick={(e) => this.handleLogoClick(e)}
              >
                <img
                  className="logo-header"
                  alt="logo PEPSiHANDICAP"
                  src="./images/svg/logo_pepsihandicap.png"
                />
              </Link>
            </li>

            <li className="nav-item list-inline-item align-middle text-nowrap">
              <NavLink
                className="w-100 p-3"
                to="/home"
                exact
                activeClassName="selected"
              >
                <FormattedMessage id="Home" />
              </NavLink>
            </li>

            <li className="nav-item list-inline-item align-middle text-nowrap">
              <NavLink
                className="w-100 p-3"
                to="/home/clients"
                exact
                activeClassName="selected"
              >
                <FormattedMessage id="Clients" />
              </NavLink>
            </li>

            <li className="nav-item list-inline-item align-middle text-nowrap">
              <NavLink
                className="w-100 p-3"
                to="/home/patients"
                exact
                activeClassName="selected"
              >
                <FormattedMessage id="Patients.Monitoring" />
              </NavLink>
            </li>

            <li className="nav-item list-inline-item align-middle text-nowrap">
              <NavLink
                className="w-100 p-3"
                to="/home/calendar"
                exact
                activeClassName="selected"
              >
                <FormattedMessage id="Calendar" />
              </NavLink>
            </li>

            <li className="nav-item list-inline-item align-middle text-nowrap">
              <NavLink
                className="w-100 p-3"
                to="/home/statistics"
                exact
                activeClassName="selected"
              >
                <FormattedMessage id="Statistics" />
              </NavLink>
            </li>

            <li className="nav-item list-inline-item align-middle text-nowrap">
              <NavLink
                className="w-100 p-3"
                to="/home/settings"
                exact
                activeClassName="selected"
              >
                <FormattedMessage id="Settings" />
              </NavLink>
            </li>

            <MenuLogo generalSettings={this.props.generalSettings} />

            <li className="menuProfile nav-item list-inline-item align-middle text-nowrap">
              <MenuProfile />
            </li>
          </ul>
        </div>

        <button
          className="navbar-toggler m-auto"
          type="button"
          data-toggle="collapse"
          data-target="#menu"
          aria-controls="menu"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
      </nav>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    generalSettings: state.generalSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: (successCallback) => dispatch(logout(successCallback)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MenuAdmin),
);
